import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  normalizeLanguage,
  type SupportedLanguage,
} from './config'
import en from './locales/en.json'
import zhCN from './locales/zh-CN.json'

export const resources = {
  en: { translation: en },
  'zh-CN': { translation: zhCN },
} as const

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    load: 'currentOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    returnNull: false,
  })

i18n.on('languageChanged', (lng) => {
  const normalized = normalizeLanguage(lng)
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalized
  }
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language)
}

export function setLanguage(lang: SupportedLanguage) {
  return i18n.changeLanguage(lang)
}

export function getLanguage(): SupportedLanguage {
  return normalizeLanguage(i18n.resolvedLanguage ?? i18n.language)
}

export default i18n
